import { IressIcon } from '@iress-oss/ids-components';
import './CreditLimitToast.css';

interface CreditLimitToastProps {
  /** Called when the adviser clicks the dismiss (×) control. */
  onDismiss: () => void;
}

/**
 * Inline toast shown in place of an AI answer when the adviser's credit
 * balance is exhausted.
 *
 * - Input remains enabled — the block is at the point of processing, not typing.
 * - Each dismissed instance stays in the transcript as the query bubble only;
 *   re-submitting while still exhausted stacks a new toast.
 * - Usage controls are rendered separately by CreditBanner (above the input)
 *   and the header pill in xplan-apex.
 */
export function CreditLimitToast({
  onDismiss
}: Readonly<CreditLimitToastProps>) {
  return (
    <div className="porter-credit-toast" role="alert" aria-live="assertive">
      <div className="porter-credit-toast__header">
        <IressIcon
          name="cancel"
          className="porter-credit-toast__icon"
          aria-hidden="true"
        />
        <p className="porter-credit-toast__heading">
          You&apos;ve reached your current AI plan limit
        </p>
        <button
          type="button"
          className="porter-credit-toast__dismiss"
          onClick={onDismiss}
          aria-label="Dismiss credit limit message"
        >
          <IressIcon name="close" aria-hidden="true" />
        </button>
      </div>
      <p className="porter-credit-toast__body">
        AI credits reset on the 1st day of every month, or contact your Site administrator for more credits.
      </p>
    </div>
  );
}
